var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 82,
    viewBox: "0 0 72 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0031 0.846353C45.5489 -0.889836 41.3412 0.502895 39.605 3.9571C37.8688 7.41131 39.2616 11.619 42.7158 13.3551C47.15 15.5839 57.3403 24.2844 57.7657 39.3867C57.8745 43.2512 61.0956 46.2957 64.96 46.1868C68.8245 46.078 71.869 42.857 71.7601 38.9925C71.1529 17.436 56.741 4.73565 49.0031 0.846353ZM9.29252 10.235C5.53875 9.31033 1.74609 11.6037 0.821386 15.3575C-0.103319 19.1113 2.1901 22.9039 5.94387 23.8287C11.9066 25.2975 21.17 29.6306 28.5326 37.7013C35.7117 45.5708 41.2557 57.155 40.0203 73.8457C39.735 77.7012 42.6291 81.058 46.4845 81.3433C50.34 81.6287 53.6968 78.7346 53.9821 74.8791C55.5165 54.1489 48.5099 38.8269 38.8754 28.2659C29.4246 17.9061 17.6115 12.2843 9.29252 10.235Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnions);
export default __webpack_public_path__ + "static/media/Unions.2c09baca1001d69a1e15324f2792564c.svg";
export { ForwardRef as ReactComponent };